module.exports = __webpack_public_path__ + "3981ab2b68ac10648cda2f38d621ae13.jpg";